module.exports = __webpack_public_path__ + "static/media/redDartThrown.d1a5b207.svg";